import React from "react";

const NotFound = () => {
  return <h4>Not Found</h4>;
};

export default NotFound;
